import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d1ee455")

_pushScopeId("data-v-7d1ee455")
const _hoisted_1 = {
  class: "product-list-item",
  "data-test": "productVariationListItem"
}
const _hoisted_2 = { class: "product-wrapper" }
const _hoisted_3 = { class: "product" }
const _hoisted_4 = { class: "product__price" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "product__edit" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-angle-right" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ['status', _ctx.statusStyle]
    }, null, 2),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", null, _toDisplayString(_ctx.productVariation.size), 1),
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.formatCurrency(_ctx.productVariation.price)), 1)
      ]),
      _hoisted_5
    ])
  ]))
})